import { Button } from "@/components/ui/button";
import { ChartLineUp } from "@phosphor-icons/react";

export function AuthConnectionError() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F5F5F9] px-5">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-white shadow-sm">
          <ChartLineUp className="h-7 w-7" weight="light" />
        </div>
        <div>
          <h1 className="text-xl font-semibold tracking-tight text-[var(--text-title)]">
            Не удалось подключиться к CRM
          </h1>
          <p className="mt-2 text-sm text-[var(--text-secondary)]">
            Проверьте подключение и попробуйте снова.
          </p>
        </div>
        <Button
          onClick={() => window.location.reload()}
          className="min-h-11 rounded-full px-5"
        >
          Повторить подключение
        </Button>
      </div>
    </div>
  );
}
